import {
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// target group By SN
function getTargetGroupsBySN(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/serial-number/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createTargetGroupsBySN(requestBody) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const endPoint = `/api/admin/v1/groups/serial-number`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editTargetGroupsBySN(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/serial-number/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function addTargetGroupsBySN(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/serial-number/${groupId}/targets`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function removeTargetGroupsBySN(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { groupId, target } = queryParams;
  const endPoint = `/api/admin/v1/groups/serial-number/${groupId}/targets/${target}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteTargetGroupsBySN(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/serial-number/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteTargetGroups(requestBody, queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/serial-number/${groupId}/targets`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const targetGroupsSNService = {
  getTargetGroupsBySN,
  createTargetGroupsBySN,
  editTargetGroupsBySN,
  addTargetGroupsBySN,
  removeTargetGroupsBySN,
  deleteTargetGroupsBySN,
  deleteTargetGroups,
};
